// extracted by mini-css-extract-plugin
export var addToCartButton = "_s1-b";
export var arrowButtonContainer = "_s1-9";
export var arrowButtonIcon = "_s1-a";
export var carouselArrowButton = "_s1-6";
export var carouselElementContainer = "_s1-1";
export var left = "_s1-7";
export var productDisplayCarouselContainer = "_s1-0";
export var productTileContainer = "_s1-2";
export var productTileImage = "_s1-4";
export var productTileImageContainer = "_s1-3";
export var productTileTitle = "_s1-5";
export var right = "_s1-8";
export var sliderOverflow = "_s1-c";